module.exports = __webpack_public_path__ + "static/img/dilemma02.ef202b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dilemma02.png
// module id = Ma+M
// module chunks = 34